module.exports = __webpack_public_path__ + "static/img/sorrow2.6fa7a322.png";